import styled from 'styled-components';
import { font, themedColor } from '@lemonade-hq/cdk';
import { Section as BaseSection } from '@/components/shared/Content';

export const Title = styled.h2`
  ${font('main', { fontSize: '3.2rem', lineHeight: '4rem', fontWeight: 700 })};
  text-wrap: balance;
  margin-bottom: 20px;
`;

export const SmallUppercase = styled.span`
  ${font('main', { fontSize: '1.2rem', lineHeight: '1.6rem', fontWeight: 700 })};
  text-wrap: balance;
  text-transform: uppercase;
  color: ${themedColor('textSecondary')};
`;

export const MediumTitle = styled.h3`
  ${font('main', { fontSize: '2.4rem', lineHeight: '3.2rem', fontWeight: 700 })};
  text-wrap: balance;
`;

export const MediumSmallTitle = styled.h3`
  ${font('main', { fontSize: '2.0rem', lineHeight: '2.8rem', fontWeight: 700 })};
  text-wrap: balance;
`;

export const SmallTitle = styled.h3`
  ${font('main', { fontSize: '1.6rem', lineHeight: '2.4rem', fontWeight: 700 })};
  text-wrap: balance;
`;

export const Section = styled(BaseSection).attrs({
  as: 'main',
})`
  ${font('main', { fontSize: '1.6rem', lineHeight: '28px' })};
  width: 100%;
`;

export const BackButton = styled.button`
  ${font('main', { fontSize: '1.4rem', lineHeight: '28px' })};
  text-wrap: balance;
  background-color: transparent;
  border: none;
  cursor: pointer;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${themedColor('metal')};
  padding: 0;
`;

export const SectionParagraph = styled.p`
  ${font('main', { fontSize: '1.6rem', lineHeight: '145%' })};
  text-align: left;
  color: ${themedColor('textPrimary')};
  text-wrap: pretty;
`;
